import { render, staticRenderFns } from "./EagleAdvanceTap.vue?vue&type=template&id=40be0670&"
import script from "./EagleAdvanceTap.vue?vue&type=script&lang=js&"
export * from "./EagleAdvanceTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40be0670')) {
      api.createRecord('40be0670', component.options)
    } else {
      api.reload('40be0670', component.options)
    }
    module.hot.accept("./EagleAdvanceTap.vue?vue&type=template&id=40be0670&", function () {
      api.rerender('40be0670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_marginnote_landing/components/AppSale/EagleAdvanceTap.vue"
export default component.exports